import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  QuestionEyebrow,
  QuestionTitle,
  QuestionHelper,
  QuestionBodyBox,
} from './styled';

interface QuestionShellProps {
  eyebrowKey: string;
  titleKey: string;
  helperKey: string;
  children: ReactNode;
}

const QuestionShell = ({
  eyebrowKey,
  titleKey,
  helperKey,
  children,
}: QuestionShellProps) => {
  const { t } = useTranslation('common');

  return (
    <div>
      <QuestionEyebrow>{t(eyebrowKey)}</QuestionEyebrow>
      <QuestionTitle>{t(titleKey)}</QuestionTitle>
      <QuestionHelper>{t(helperKey)}</QuestionHelper>
      <QuestionBodyBox>{children}</QuestionBodyBox>
    </div>
  );
};

export default QuestionShell;
